export default "__VITE_ASSET__DXgw4gEm__"